import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { StudyFacade } from '../../state/study/study.facade';
import { STUDY_TOPIC, StudyMessages } from './study.messages';

@Injectable()
export class StudyWsService extends BaseWsService {
  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService,
    private studyFacade: StudyFacade
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  setTopic(studyId: string) {
    this.topic = `${STUDY_TOPIC}/${studyId}`;
  }

  protected get excludedMessagesFromLog(): string[] {
    return [StudyMessages.ProgressMessage];
  }

  handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    const payload = message.payload;
    switch (message.description) {
      case StudyMessages.LogMessage:
        this.logMessage(payload.message);
        break;
      case StudyMessages.ProgressMessage:
        this.studyFacade.updateAddBleenGroupProgress(payload.bleenGroupId, payload.progress);
        break;
    }
  }
}
